<!-- <div class="d-lg-block d-none">
    <div class="sorting">
        <div class="sort-by">
            Sort By:
        </div>
        <ul class="sorting-order">
            <li> <a [ngClass]="{'active': selectedSort == 1}" href="javascript:void(0);" (click)="productSort(1, 'rsp', 'desc')" title="Rsp: High to low">RSP: High to low</a> </li>
            <li> <a [ngClass]="{'active': selectedSort == 2}"  href="javascript:void(0);" (click)="productSort(2, 'rsp', 'asc')" title="Rsp: Low to high">RSP: Low to high</a> </li>
            <li> <a [ngClass]="{'active': selectedSort == 3}" href="javascript:void(0);" (click)="productSort(3, 'short_desc', 'asc')" title="Ascending A-Z">Ascending A-Z</a></li>
            <li> <a [ngClass]="{'active': selectedSort == 4}" href="javascript:void(0);" (click)="productSort(4, 'short_desc', 'desc')" title="Descending Z-A">Descending Z-A</a> </li>
        </ul>
    </div>
</div>
<div class="d-lg-none d-block product-sorting">
    <div class="btn-group" dropdown>
        <button id="button-basic" dropdownToggle type="button" class="btn  dropdown-toggle"
            aria-controls="dropdown-basic">
            Sort 
        </button>
        <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu " role="menu" aria-labelledby="button-basic">
            <li role="menuitem"><a [ngClass]="{'active': selectedSort == 1}" class="dropdown-item" (click)="productSort(1, 'rsp', 'desc')" href="javascript:void(0);">RSP: High to low</a></li>
            <li role="menuitem"><a [ngClass]="{'active': selectedSort == 2}" class="dropdown-item" (click)="productSort(2, 'rsp', 'asc')" href="javascript:void(0);">RSP: Low to high</a></li>
            <li role="menuitem"><a [ngClass]="{'active': selectedSort == 3}" class="dropdown-item" (click)="productSort(3, 'short_desc', 'asc')" href="javascript:void(0);">Ascending A-Z</a></li>
            <li role="menuitem"><a ngClass]="{'active': selectedSort == 4}" class="dropdown-item" (click)="productSort(4, 'short_desc', 'desc')" href="javascript:void(0);">Descending Z-A</a></li>
        </ul>
    </div>
</div> -->



<div class="sort-div">
    <div class="btn-group" dropdown>
        <button id="button-basic" dropdownToggle type="button" class="btn btn-primary dropdown-toggle"
            aria-controls="dropdown-basic">
            Sort By <img src="../../assets/images/dropdown-caret.svg" alt="">
        </button>
        <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-basic">
            <li role="menuitem"><a [ngClass]="{'active': selectedSort == 3}" (click)="productSort(3, 'short_desc', order == 'asc' ? 'desc' : 'asc')" class="dropdown-item" href="javascript:void(0);">Alphabetically
                <img *ngIf="order == 'desc' && selectedSort == 3" class="px-2"
                        src="../../../../assets/images/down-sort-by-arrow.svg" alt="">
                        <img *ngIf="order == 'asc' && selectedSort == 3" class="px-2"
                        src="../../../../assets/images/up-sort-by-arrow.svg" alt="">
            </a></li>
            <li role="menuitem"><a [ngClass]="{'active': selectedSort == 1}" (click)="productSort(1, 'rsp', order == 'asc' ? 'desc' : 'asc')" class="dropdown-item" href="javascript:void(0);">RSP 
                <img *ngIf="order == 'desc' && selectedSort == 1" class="px-2"
                        src="../../../../assets/images/down-sort-by-arrow.svg" alt="">
                        <img *ngIf="order == 'asc' && selectedSort == 1 " class="px-2"
                        src="../../../../assets/images/up-sort-by-arrow.svg" alt=""></a></li>
            <li role="menuitem"><a [ngClass]="{'active': selectedSort == 2}" (click)="productSort(2, 'cost', order == 'asc' ? 'desc' : 'asc')" class="dropdown-item" href="javascript:void(0);">Cost
                <img *ngIf="order == 'desc' && selectedSort == 2" class="px-2"
                        src="../../../../assets/images/down-sort-by-arrow.svg" alt="">
                        <img *ngIf="order == 'asc' && selectedSort == 2" class="px-2"
                        src="../../../../assets/images/up-sort-by-arrow.svg" alt="">
            </a></li>
            
        </ul>
    </div>
</div>